export class Reservation {
    uuid_event_occurrence: string;
    number_of_users?: number;
    passengers?: Array<string>;
    users_in_wl?: Array<string>;

    constructor() {
        this.passengers = new Array<string>();
    }
}

export class ExistingReservation {
    uuid_old_reservation: string;
    old_number_of_users: number;
    uuid_old_event_occurrence: string;

    constructor() {
    }
}

export class ReservationSummary {
    uuid_reservation: string;
    uuid_passenger?: string;
    uuid_employee?: string;
    displayName: string;
    badgeNumber: string;
    creation_datetime: string;
    event_occurrence_datetime: string;
    event_ticket_datetime: string;
    ticket_file_name: string;
    number_of_users: number;
    uuid_event_occurrence: string;
    is_editable: boolean;
    event_dates: Array<string>;
    is_waiting_list?: boolean;

    constructor(
        uuid: string,
        uuid_passenger: string,
        uuid_employee: string,
        profile: string,
        badge: string,
        creation: string,
        occurrence: string,
        occurrence_ticket: string,
        ticket_file_name: string,
        number_of_users: number,
        uuid_event_occurrence: string,
        event_dates: Array<string>,
        editable: boolean,
        is_waiting_list?: boolean
    ) {
        this.uuid_reservation = uuid;
        this.uuid_passenger = uuid_passenger;
        this.uuid_employee = uuid_employee;
        this.displayName = profile;
        this.badgeNumber = badge;
        this.creation_datetime = creation;
        this.event_occurrence_datetime = occurrence;
        this.event_ticket_datetime = occurrence_ticket;
        this.number_of_users = number_of_users;
        this.uuid_event_occurrence = uuid_event_occurrence;
        this.event_dates = event_dates;
        this.is_editable = editable;
        this.ticket_file_name = ticket_file_name;
        this.is_waiting_list = is_waiting_list;
    }
}